import { z } from "zod"

import { ProductShelvingRequirementBinSize } from "@/graphql/codegen/graphql"

export interface ProductShelvingRequirement {
  coldStorage: boolean
  h3ColdStorage: boolean
  binSize: ProductShelvingRequirementBinSize
  deep: boolean
  stackable: boolean
}

export const productShelvingRequirementFormSchema = z
  .object({
    coldStorage: z
      .boolean()
      .nullable()
      .refine((value): boolean | null => value !== null, { message: "Select Cold Storage option" }),
    h3ColdStorage: z.boolean().nullable(),
    binSize: z.union([
      z.nativeEnum(ProductShelvingRequirementBinSize),
      z.string().min(1, { message: "Bin Size is required" }),
    ]),
    deep: z
      .boolean()
      .nullable()
      .refine((value): boolean | null => value !== null, { message: "Select Deep Storage option" }),
    stackable: z
      .boolean()
      .nullable()
      .refine((value): boolean | null => value !== null, { message: "Select Stackable option" }),
  })
  .superRefine((values, ctx) => {
    if (values.coldStorage && values.h3ColdStorage === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Select H3 storage option",
        path: ["h3ColdStorage"],
      })
    }
  })

export type ProductShelvingRequirementFormValues = z.infer<typeof productShelvingRequirementFormSchema>

export const productAislesPreferenceFormSchema = z.object({
  warehouse: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .refine(({ id }) => !!id, { message: "Warehouse is required" }),
  location: z.string().min(1, { message: "Locations is required" }),
  aisles: z.array(z.string()).min(1, { message: "Select at least 1 aisle option" }),
})

export type ProductAislesPreferenceFormValues = z.infer<typeof productAislesPreferenceFormSchema>
